// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__33QXC","card":"Cards_card__1o4Yv","infected":"Cards_infected__2tDpS","recovered":"Cards_recovered__3UDNH","deaths":"Cards_deaths__1asAl"};